import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionPacksComponent } from './subscription-packs/subscription-packs.component';
import { RouterModule } from '@angular/router';
import { SubscriptionInfoComponent } from './subscription-info/subscription-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppLoginModule } from '../app-login/app-login.module';
import { SubscriptionInfoService } from './subscription-info-service.service';
import { NgxCarouselModule } from 'ngx-carousel';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    AppLoginModule,
    FormsModule,
    ReactiveFormsModule,

    BrowserModule,
      NgbModule,
      // TranslateModule

      NgxCarouselModule
  ],
  exports: [SubscriptionPacksComponent, SubscriptionInfoComponent],
  declarations: [SubscriptionPacksComponent, SubscriptionInfoComponent],
  providers: [SubscriptionInfoService]
})
export class SubscriptionPackagesModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/subscription-packages/subscription-packages.module.ts